class DefaultRequest {

    public hasProp(name: string): boolean {
        // eslint-disable-line @typescript-eslint/no-explicit-any
        return typeof (this as object)[name] !== 'undefined';
    }


    public fromObject(obj: object): void {
        (Object.keys(obj) as (keyof typeof obj)[]).forEach((key) => {
            // @typescript-eslint/no-explicit-any
            if (this.hasProp(key)) {
                this[key] = obj[key];
            }
        });
    }

    public isEmpty(data: string): boolean {
        return data.trim().length === 0;
    }

    public toUrl(): string {
        const params = new URLSearchParams(JSON.parse(JSON.stringify(this)));
        params.delete('errors');
        if (params.has('token'))
            params.delete('token');

        return window.location.origin + window.location.pathname + '?' + params.toString();
    }
}

export default DefaultRequest;
